import { render, staticRenderFns } from "./Step-1.vue?vue&type=template&id=0f5779ce&scoped=true&"
import script from "./Step-1.vue?vue&type=script&lang=js&"
export * from "./Step-1.vue?vue&type=script&lang=js&"
import style0 from "./Step-1.vue?vue&type=style&index=0&id=0f5779ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5779ce",
  null
  
)

export default component.exports